/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_AllergyPreferencesOptions_ } from "../models/DataMessageResponse_AllergyPreferencesOptions_";
import type { DataMessageResponse_Medical_ } from "../models/DataMessageResponse_Medical_";
import type { DataResponse_Medical_ } from "../models/DataResponse_Medical_";
import type { Medical } from "../models/Medical";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class MedicalService {
  /**
   * Update Medical Info
   * Updates the medical info for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_Medical_ Successful Response
   * @throws ApiError
   */
  public static updateMedicalInfoApiV1MedicalPut(
    xUserId: string,
    requestBody: Medical,
  ): CancelablePromise<DataMessageResponse_Medical_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/medical",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Medical Info
   * Returns the medical info for a user.
   * @param xUserId
   * @returns DataResponse_Medical_ Successful Response
   * @throws ApiError
   */
  public static getMedicalInfoApiV1MedicalGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_Medical_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/medical",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Allergy Options
   * Get available allergy preference options.
   * @returns DataMessageResponse_AllergyPreferencesOptions_ Successful Response
   * @throws ApiError
   */
  public static getAllergyOptionsApiV1MedicalAllergyOptionsGet(): CancelablePromise<DataMessageResponse_AllergyPreferencesOptions_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/medical/allergy-options",
    });
  }
  /**
   * Get Medical Info By Admin
   * Used by an admin to get information about a user's medical info.
   * @param userId
   * @returns DataResponse_Medical_ Successful Response
   * @throws ApiError
   */
  public static getMedicalInfoByAdminApiV1MedicalUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_Medical_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/medical/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
